import Vue from "vue";
import api from "@/api";
import deepClone from "@/utils/deep-clone";

/**
 * STATE
 */
const state = {
    notifications: [],
};

/**
 * GETTERS
 */
const getters = {
    notifications(state) {
        return deepClone(state.notifications);
    },
};

/**
 * ACTIONS
 */
const actions = {
    getMyNotifications({ commit }) {
        return api.get("/api/notifications/get/all/all").then(({ data }) => {
            commit("setNotifications", { notifications: data });
        });
    },
    getNotifications(
        { commit },
        { payload: { userId = "", type = "profileVisit" } } = { payload: {} },
    ) {
        return api.get(`/api/notifications/get/${type}/${userId}`).then(({ data }) => {
            commit("setNotifications", { notifications: data });
        });
    },
    dismissNotification(
        { dispatch, commit },
        { payload: { notificationId = "" } } = { payload: {} },
    ) {
        // optimistic update before getting the backend data
        commit("removeSingleNotification", { notificationId });

        return api
            .post("/api/notifications/update", {
                _id: notificationId,
                isDismissed: true,
                isDone: false,
            })
            .then(() => {
                dispatch("getMyNotifications");
            });
    },
};

/**
 * MUTATIONS
 */
const mutations = {
    setNotifications(state, { notifications = [] } = {}) {
        state.notifications = notifications;
    },
    removeSingleNotification(state, { notificationId } = {}) {
        if (!Array.isArray(state.notifications)) return;

        const notificationIndex = state.notifications?.findIndex(
            notification => notification._id === notificationId,
        );

        if (notificationIndex === -1) return;

        Vue.delete(state.notifications, notificationIndex);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
